/** @file Dirty-state helpers for warning before unsaved editor changes are discarded. */
import { appStore } from "./state.js";

/** @type {string | null} */
let cleanSnapshot = null;

/** @returns {string} */
function snapshotEditorState() {
  const state = appStore.get();
  return JSON.stringify({
    tokens: state.tokens,
    drawings: state.drawings,
    scenes: state.scenes,
    activeSceneIndex: state.activeSceneIndex,
  });
}

export function markEditorClean() {
  cleanSnapshot = snapshotEditorState();
}

export function isEditorDirty() {
  if (cleanSnapshot === null) {
    markEditorClean();
    return false;
  }
  return snapshotEditorState() !== cleanSnapshot;
}

export function resetEditorDirtyBaseline() {
  cleanSnapshot = null;
}

/**
 * @param {string} message
 * @returns {boolean}
 */
export function confirmDiscardDirtyEditor(message = "Nicht gespeicherte Änderungen verwerfen?") {
  if (!isEditorDirty()) {
    return true;
  }
  if (typeof window === "undefined" || typeof window.confirm !== "function") {
    return true;
  }
  return window.confirm(message);
}
